import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Container,
  Grid,
  Box,
  Card,
  CardMedia,
} from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import { Api } from "../../../Utils/Api";
import { Loader } from "../../../Components/Loader";
import { useParams } from "react-router-dom";
import { app_base_url } from "../../../Utils/Urls";
import { useSistemaStorage } from "../../../Storage/SistemaStorage";
import { useUsuario } from "../../../Hooks/UsuarioHook";

export function AdicionarSistema() {
  const [loading, setLoading] = useState(false);
  const { getSistemaPorId, sistemaFocus } = useSistemaStorage();
  const{usuario} = useUsuario();
  const { id } = useParams();

  const [titulo, setTitulo] = useState("");
  const [descricao, setDescricao] = useState("");
  const [imagem, setImagem] = useState<File | null>(null);
  const [url, setUrl] = useState("");
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  useEffect(() => {
    if (id && usuario) {
      // Carregar dados do sistema para edição
      getSistemaPorId(Number(id));
    }
  }, [id, usuario]);

  useEffect(()=>{
    if(sistemaFocus.id){
      setTitulo(sistemaFocus.titulo);
      setDescricao(sistemaFocus.descricao);
      setUrl(sistemaFocus.url);
      setPreviewUrl(sistemaFocus.logo || null);
    }
  },[sistemaFocus])
  const handleTituloChange = (event: any) => setTitulo(event.target.value);
  const handleDescricaoChange = (event: any) => setDescricao(event.target.value);
  const handleUrlChange = (event: any) => setUrl(event.target.value);

  const handleImagemChange = (event: any) => {
    const file = event.target.files[0];
    if (file && file.type && /^image\/(png|jpe?g)$/.test(file.type)) {
      setImagem(file);
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      setImagem(null);
      setPreviewUrl(null);
    }
  };

  const handleSubmit = async (event: any) => {
    setLoading(true);
    event.preventDefault();

    const formData = new FormData();
    formData.append("titulo", titulo);
    formData.append("descricao", descricao);
    formData.append("url", url);

    if (id) formData.append("id", id); // Adiciona o ID em caso de edição
    if (imagem) formData.append("file", imagem); // Envia imagem apenas se selecionada

    try {
      if (id) {
        await Api.put(`/sistema/`, formData); // Editar sistema
      } else {
        await Api.post(`/sistema`, formData); // Criar novo sistema
      }
      // Reload de verdade (e não navigate): a lista de sistemas vive no contexto
      // do usuário, carregada no boot via /checar-token + /meus-sistemas. Com
      // navigate a tela abriria com a lista velha, sem o sistema recém-criado.
      window.location.assign(`${app_base_url}/sistemas-liberados`);
    } catch (error) {
      console.error("Erro ao salvar o sistema:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <h1>{id ? "Editar Sistema" : "Adicionar Sistema"}</h1>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <input
              accept="image/png,image/jpeg"
              id="contained-button-file"
              type="file"
              onChange={handleImagemChange}
              style={{ display: "none" }}
            />
            <label htmlFor="contained-button-file">
              <Button
                variant="contained"
                component="span"
                startIcon={<PhotoCamera />}
              >
                Upload de Imagem
              </Button>
            </label>
          </Grid>
          <Grid item xs={12}>
            {previewUrl && (
              <Box mt={2}>
                <Card>
                  <CardMedia
                    component="img"
                    image={previewUrl}
                    alt="Imagem selecionada"
                  />
                </Card>
              </Box>
            )}
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Título"
              variant="outlined"
              value={titulo}
              onChange={handleTituloChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Descrição"
              variant="outlined"
              multiline
              rows={4}
              value={descricao}
              onChange={handleDescricaoChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="URL"
              variant="outlined"
              value={url}
              onChange={handleUrlChange}
            />
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" type="submit">
              {id ? "Salvar Alterações" : "Adicionar Sistema"}
            </Button>
          </Grid>
        </Grid>
      </form>
      <Loader loading={loading} />
    </Container>
  );
}
